import React, { useCallback, useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'antd';
import { EditDocumentIcon } from '../../../resource/icons';
import { useDispatch } from 'react-redux';
import actions from '../store/actions/edit-document.actions';
import { DocumentReminderCheckboxGroup } from '../CompanyDocumentReminder/DocumentReminderCheckboxGroup';

const fieldName = 'notificationTypeId';

export const EditReminderModal = ({
  onCancel,
  visible,
  fprops,
  getFieldDecorator,
  validateFields,
  prepareDataAndResetFields,
  form,
}) => {
  const dispatch = useDispatch();

  const [checkedList, setCheckedList] = useState(
    fprops.notificationFrequencyTypeId || []
  );

  getFieldDecorator(fieldName, {
    initialValue: [],
  });

  useEffect(() => {
    const initialValue = visible
      ? fprops.notificationFrequencyTypeId || []
      : [];
    setCheckedList(initialValue);
  }, [fprops.notificationFrequencyTypeId, getFieldDecorator, visible]);

  const onChange = (value) => {
    setCheckedList(value);
  };

  useEffect(() => {
    form.setFieldsValue({ [fieldName]: checkedList });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(checkedList)]);

  const onOk = useCallback(() => {
    validateFields((err, values) => {
      if (err) return;
      const v = prepareDataAndResetFields(values);
      dispatch(actions.updateNotification(v.id, v[fieldName]));
      dispatch(actions.closeModal());
    });
  }, [dispatch, prepareDataAndResetFields, validateFields]);

  return (
    <Modal
      style={{ minWidth: 350 }}
      width={350}
      visible={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EditDocumentIcon
            style={{
              height: 40,
              verticalAlign: 'middle',
              marginRight: 10,
            }}
          />
          <div>Уведомления документа</div>
        </div>
      }
      okText="Изменить"
      onCancel={onCancel}
      onOk={onOk}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={24}>
            <Form.Item>
              <DocumentReminderCheckboxGroup
                allowEmpty={true}
                loading={false}
                value={checkedList}
                onChange={onChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
